import Vue from 'vue';
import VueJwtDecode from 'vue-jwt-decode';

Vue.use(VueJwtDecode);
